import * as classes from "../css/physiotherapie.module.css";
import { transition } from "./util/transition";
import React from "react";
import { useInView } from "react-intersection-observer";

export default function Physiotherapie(): React.ReactElement {
  const { ref, inView } = useInView({
    threshold: 0.1,
    rootMargin: "100px 0px -100px 0px",
    initialInView: true,
  });

  return (
    <section
      ref={ref}
      className="-skew-y-8 transform bg-white -mt-28 md:pt-28 pb-96 text-black"
    >
      <div className="skew-y-8 transform pb-10">
        <div className="max-w-screen-2xl m-auto px-6 xl:px-14">
          <div className="flex flex-col md:flex-row justify-between gap-4 md:gap-12 xl:gap-44">
            <div className="flex-1 text-right md:text-left" role="presentation">
              <span
                className={classes.subtitle}
                style={{
                  transition: transition(inView, 0),
                  transform: `translateY(${inView ? "0" : "-1rem"})`,
                  opacity: inView ? 1 : 0,
                }}
              >
                Erhalte Deine
              </span>{" "}
              <span
                className={classes.title}
                style={{
                  letterSpacing: 0.8,
                  transition: transition(inView, 100),
                  transform: `translateY(${inView ? "0" : "-1rem"})`,
                  opacity: inView ? 1 : 0,
                }}
              >
                Beweglichkeit
              </span>
            </div>
            <div className="flex-1 xl:-ml-10">
              <span
                id="physiotherapie"
                style={{
                  position: "relative",
                  top: "calc(-10rem - 10vw)",
                }}
              />
              <h2
                className={classes.orangeTitle}
                style={{
                  transition: transition(inView, 300),
                  transform: `translateY(${inView ? "0" : "-1rem"})`,
                  opacity: inView ? 1 : 0,
                }}
              >
                Physiotherapie
              </h2>
              <p
                className={classes.content}
                style={{
                  transition: transition(inView, 400),
                  transform: `translateY(${inView ? "0" : "-1rem"})`,
                  opacity: inView ? 1 : 0,
                }}
              >
                Bereiten Dir schon kleine <b>Bewegungen</b> im Alltag{" "}
                <b>Schmerzen</b>, fühlst Du Dich schnell in Deiner Flexibilität
                eingeschränkt? Durch einen Mix aus <b>Massage</b> und
                Gymnastik-Übungen löse ich Deine
                <b>Verspannungen</b> und gebe Deinen Gelenken ihre{" "}
                <b>Beweglichkeit</b>
                zurück. Mit Trainingsgeräten wie Gymnastikbällen und Dehnbändern
                baue ich Deine Muskulatur nachhaltig auf. Damit Du Dich auch in
                Zukunft frei bewegen kannst.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
